// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","443":"about"}[chunkId] || chunkId) + "." + {"167":"915ae77a","443":"64d8bf50","841":"e9da2955"}[chunkId] + ".js";
};